<template>
  <div class="filter">
    <div class="filter__content">
      <form :class="{ 'form-inline': $breakpoint.lgAndUp }" v-if="ready">
        <div v-for="(filter, idx) in filterData" :key="`filter-${idx}`">
          <b-form-select
            v-if="filter.type === 'select' && filter.items.length > 1"
            class="filter__select"
            v-model="filterSelections[filter.label]"
            :options="filter.items"
            @change="updateFilter"
            :aria-label="filter.aria"
          ></b-form-select>

          <div class="form-check">
            <b-form-checkbox
              v-if="filter.type === 'checkbox'"
              v-model="filterSelections[filter.label]"
              @change="updateFilter"
              :aria-label="filter.aria"
              >{{ filter.label }}
            </b-form-checkbox>
          </div>
        </div>
        <div v-if="showReset" class="filter__reset">
          <button
            type="button"
            @click.prevent="resetFilter"
            aria-label="Reset results"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
    <div class="filter__status sr-only" aria-live="polite">{{ status }}</div>
  </div>
</template>

<script lang="js">
import { BFormSelect, BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'ahc-filter',
  components: {
    BFormSelect,
    BFormCheckbox,
  },
  props: {
    filterData: {
      type: Object,
      required: true
    },
    showReset: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    filtersSet() {
      let matches = [];
      Object.keys(this.filterSelections).forEach((filterKey) => {
        if (this.filterSelections[filterKey].length > 0) {
          matches.push(this.filterSelections[filterKey]);
        }
      });
      return matches.length > 0;
    }
  },
  watch: {},
  data() {
    return {
      selected: null,
      filterSelections: {},
      query: null,
      ready: false,
      status: '',
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Either pre-populate filters from query params
     * or send ready event to results component
     */
    init() {
      this.setFilterDefaults();

      // Check for filter params in the url query
      if (Object.keys(this.$route.query).length !== 0) {
        this.query = this.$route.query;
        this.preFilter();
      } else {
        // if no filters need pre-processing,
        // send ready signal to results
        this.ready = true;
        this.$emit('filterReady', true);
      }
    },
    /**
     * If query params exist on load, send those
     * filter selections to the results component
     */
    preFilter() {
      const vm = this;
      const newQuery = {};
      // format data object
      Object.keys(vm.query).map(function (param) {
        newQuery[param] = (vm.query[param] === 'true') ? true : vm.query[param];
      });

      // update filter dropdowns
      vm.filterSelections = newQuery;

      // send event to results
      this.ready = true;
      this.$emit('filterReady', true);
      vm.$emit('filterUpdate', newQuery);
    },
    /**
     * when the filter options are changed, fire an
     * event that the results component uses to update results
     */
    updateFilter() {
      this.status = '';
      this.$nextTick(() => {
        this.updateQueryParams();
      })
    },
    resetFilter() {
      this.ready = false;
      this.setFilterDefaults();
      this.$router.replace({query: null});

      this.$nextTick(() => {
        this.ready = true;
        this.$emit('filterReset');
        this.status = 'Search filter has been reset.';
      });
    },
    setFilterDefaults() {
      Object.keys(this.filterData).forEach((filterKey) => {
        const filter = this.filterData[filterKey];
        this.filterSelections[filter.label] = filter.items[0].value;
      });
    },
    /**
     * Update url query params with current filter options
     */
    updateQueryParams() {
      // loop over filter selections and join their values by key
      let newObject = {};
      Object.keys(this.filterSelections).forEach((filterKey) => {
        if (this.filterSelections[filterKey] !== '' && this.filterSelections[filterKey] !== false) {
          newObject[filterKey] = this.filterSelections[filterKey];
        }
      })
      this.$router.replace({query: newObject});
      this.$emit('filterUpdate', this.filterSelections);
    },
  },
}
</script>

<style lang="scss">
@import "filter";
</style>
